import { render } from "./management.cattle.io.globalrole.vue?vue&type=template&id=66a1f15d&scoped=true"
import script from "./management.cattle.io.globalrole.vue?vue&type=script&lang=js"
export * from "./management.cattle.io.globalrole.vue?vue&type=script&lang=js"

import "./management.cattle.io.globalrole.vue?vue&type=style&index=0&id=66a1f15d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66a1f15d"]])

export default __exports__